import React from "react"
import Dropdown from "src/shared/components/forms/selelct-dropdown/Dropdown"
import { useOpcionesDescuentos } from "src/shared/modals/ModalDescuentos/hooks/useOpcionesDescuentos"
import { Descuento, FilterDescuentos } from "src/shared/modals/ModalDescuentos/ModalDescuentos.type"
import "./Descuento.css"

interface DescuentoInputProps {
    filter: FilterDescuentos
    value: string
    onChange: (descuento: Descuento) => void
    disabled?: boolean
}

const DescuentoInput: React.FC<DescuentoInputProps> = ({ filter, value, onChange, disabled }) => {
    const { opciones_descuentos, loading } = useOpcionesDescuentos(filter)

    return (
        <div className="descuento-input">
            <Dropdown
                icon="priceTag"
                iconInOptions={false}
                label="Descuento (Opcional)"
                placeholder="Selecciona una opción"
                options={opciones_descuentos}
                value={value}
                onClick={(option) => {
                    if (String(option.value) === value) {
                        onChange({ descuento_id: "", total: 0, nombre: "" })
                        return
                    }
                    const find = opciones_descuentos.find(o => o.value === option.value)
                    if (!find) return
                    onChange({
                        descuento_id: String(find.value),
                        total: Number(find.total) || 0,
                        nombre: String(find.label),
                        tipo_descuento: find.tipo_descuento as string | undefined,
                        valor: find.valor !== undefined ? Number(find.valor) : undefined,
                    })
                }}
                disabled={loading || disabled}
            />
        </div>
    )
}

export default DescuentoInput
